import { Component, OnInit } from '@angular/core';
import { ProspectOpenhouse } from 'app/models/prospect-openhouse';
import { Router, ActivatedRoute } from '@angular/router';
import { ProspectService } from 'services/prospect.service';
import { createCalendar } from 'add-to-calendar-buttons';
import { ProspectProfileInfo } from 'app/models/prospect-profile-info';
import { ProspectTourSummary } from 'app/models/prospect-tour-summary';
import { SplashService } from 'services/splash.service';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-tour-summary',
  templateUrl: './tour-summary.component.html',
  styleUrls: ['./tour-summary.component.css']
})
export class TourSummaryComponent implements OnInit {

  address: string = null;
  tourType: string = null;
  tourSummary: ProspectTourSummary = new ProspectTourSummary();
  errorMessage: string = null;
  sub: any
  recordKey: number = null;
  prospectInfo: ProspectProfileInfo = new ProspectProfileInfo();
  minMoveInDate: Date = new Date();
  tourTypeText: string = null;
  tourTypeDateText: string = null;


  constructor(private prospectService: ProspectService, public router: Router, public route: ActivatedRoute, private splashService: SplashService, private errorService: ErrorService) {

    let address = localStorage.getItem('PropertyAddress');
    let tourtype = localStorage.getItem('TourType');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }
    if (tourtype !== null && tourtype !== undefined)
    {
      this.tourType = tourtype;
    }

    this.sub = this.route.params.subscribe(params => {
      this.recordKey = params['recordKey'];
    });

    if (tourtype === "openhouse")
    {

      this.tourTypeText = `We look forward to seeing you at ${this.address}, for the open house scheduled`;

      this.prospectService.getOpenHouseSummary(this.recordKey).subscribe(res => this.onGetTourSummary(res), res => this.errorService.showError("Error getting open house summary."));
    }
    else if (tourtype === "showing")
    {

      this.tourTypeText = `Your showing of ${this.address} is scheduled for`;

      this.prospectService.getShowingSummary(this.recordKey).subscribe(res => this.onGetTourSummary(res), res => this.errorService.showError("Error getting showing summary."));
    }
    
    this.prospectService.getProspectProfileInfo().subscribe(res => this.onGetProspectProfileInfo(res), res => this.errorService.showError("Error getting user information."));
   }

  ngOnInit() { 
    if (this.tourType === "openhouse")
    {
      this.splashService.updateSplash("openhouse");
    }
    else if(this.tourType === "showing")
    {
      this.splashService.updateSplash("agenttour");
    }
  }

  onGetTourSummary(tour: ProspectTourSummary)
  {

    if (this.tourType === "openhouse")
    {
      this.tourTypeDateText = `${tour.DateTitle} between ${tour.StartTime} and ${tour.EndTime}.`;
    }
    else if (this.tourType === "showing")
    {
      this.tourTypeDateText = `${tour.DateTitle} at ${tour.StartTime}.`;
    }

    this.tourSummary = tour;
    this.createCalendarWidget();
  }

  onGetProspectProfileInfo(info: ProspectProfileInfo)
  {
    if (info.PreferredMoveIn !== null)
    {
      this.prospectInfo.PreferredMoveIn = new Date(info.PreferredMoveIn);
    }
    else {
      this.prospectInfo.PreferredMoveIn = new Date();
    }
    
  }

  createCalendarWidget(){

    let tempTitle = null;

    if (this.tourType === "openhouse")
    {
      tempTitle = 'Open House at ' + this.address;
    }
    else if (this.tourType === "showing")
    {
      tempTitle = 'Showing at ' + this.address;
    }

    var myCalendar = createCalendar({
      data: {
        title: tempTitle,
        start: new Date(this.tourSummary.EventStart),
        end: new Date(this.tourSummary.EventEnd),     
        address: this.address,
        description: ''
      }
    });
    
    myCalendar.querySelector('label.add-to-calendar-checkbox').innerHTML = "<span class='ui-button-icon-left ui-clickable fa fa-fw fa-calendar'></span>&nbsp;<span id='oh-summary-atc-text'>ADD TO CALENDAR</span>";

    document.querySelector('#openhouse-cal-anchor').appendChild(myCalendar);
  }

  onSubmit()
  {
    this.router.navigate(['/account/tours']);
  }

  updateSuccess(result: boolean)
  {
    this.router.navigate(['/account/tours']);
  }

  dateSelected(e)
  {
    if(e.value !== null){
      this.prospectInfo.PreferredMoveIn = new Date(e.value);
    }
  }
}
